module.exports = __webpack_public_path__ + "img/IMG_20211228_101014306.75d1c766.jpg";